<template>
  <div>
    <!-- nav -->
    <search-nav @handleSearch="onClickSearch">
      <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex ">
        <component
          v-for="(component, index) in stdSearchComponents"
          v-if="showSearchNavItem(component['options'])"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="component['options']"
          :onClickSearch="onClickSearch"
          v-model="nav.value[component['value']]"
        />
      </div>
    </search-nav>

    <!-- 목록-->
    <div class="w-full">
      <div class="flex justify-between">
        <div class="pl-2 xl:pl-0 hidden md:flex items-center" style="font-size: 18px">
          <span class="mr-2" style="font-weight: 700">{{ $t('대상 :') }}</span>
          <span>{{ list.length }}명</span>
        </div>
        <div>
          <vs-button class="mr-2" color="secondary" type="border" @click="onClickExcelDownload">{{ $t('엑셀 다운로드') }}</vs-button>
          <vs-button color="secondary" type="border" @click="onClickPrint">{{ $t('인쇄') }}</vs-button>
        </div>
      </div>
      <div class="table-container">
        <table class="w-full mt-4 sticky-table">
          <colgroup>
            <col width="140px" class="sticky-col"/>
            <col width="140px"/>
            <col width="140px"/>
            <col width="140px"/>
            <col v-for="day in (dayofMonth + 1)" />
            <col width="140px"/>
            <col width="140px"/>
            <col width="140px"/>
          </colgroup>
          <thead>
            <tr>
              <th rowspan="2" class="sticky-cell">{{ $t('성명') }}</th>
              <th rowspan="2">{{ $t('연락처') }}</th>
              <th rowspan="2">{{ $t('소속') }}</th>
              <th rowspan="2">{{ $t('직종') }}</th>
              <th :colspan="dayofMonth + 1">{{ $t('투입현황') }}</th>
              <th rowspan="2">{{ $t('단가') }}</th>
              <th rowspan="2">{{ $t('총금액') }}</th>
              <th rowspan="2">{{ $t('비고') }}</th>
            </tr>
            <tr>
              <th v-for="day in dayofMonth"><div style="min-width: 40px;">{{day}}</div></th>
              <th style="min-width: 60px;">{{ $t('투입일') }}</th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="row in list">
              <td style="min-width: 140px;" class="sticky-cell">{{ row.성명 }}</td>
              <td style="min-width: 140px;">{{ row.연락처 }}</td>
              <td style="min-width: 140px;">{{ row.소속 }}</td>
              <td style="min-width: 140px;">{{ row.직종 }}</td>

              <td v-for="day in dayofMonth">
                <div v-if="row[day]">{{ row[day] }}</div>
              </td>
              <td>{{ row.투입일 }}</td>

              <td style="min-width: 140px;">{{ row.단가 }}</td>
              <td style="min-width: 140px;">{{ row.총금액 }}</td>
              <td style="min-width: 140px;">{{ row.비고 }}</td>
            </tr>
          <tr>
            <th class="sticky-cell" :colspan="1">{{ $t('합 계') }}</th>
            <th :colspan="dayofMonth + 5"></th>
            <th>{{ 총합계 }}</th>
            <th />
          </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
import singlePageList from "@/views/boards/single-page/listIndex";
import searchComponent from "@/views/list/components/include";
import KPagination from "@/components/kPagination/kPagination.vue";
import SearchNav from "@/components/nav/SearchNav.vue";
import * as XLSX from 'xlsx';

export default {
  name: "TableListPage",
  components: {
    KPagination,
    SearchNav,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    boardId() {
      return this.$route.params.boardId;
    },
    stdSearchComponents() {
      if (singlePageList[`${this.boardId}_list`]) {
        const getComponents = singlePageList[`${this.boardId}_list`].components
        if (getComponents) {
          const stdSearchComponents = getComponents();
          if (stdSearchComponents && stdSearchComponents.length > 0) {
            for (const component of stdSearchComponents) {
              component.component = searchComponent[component['component']];
            }
          }
          return stdSearchComponents;
        }
      }
      return [];
    },
    총합계() {
      let sum = 0;
      for (const row of this.list) {
        sum += row.총금액;
      }
      return sum;
    }

  },
  data () {
    return {
      nav: {
        value: {},
      },
      list: [],

      //pagination
      perPage: 10,
      date: "",
      currentPage: 1,
      lastPage: 1,
      total: 0,

      dayofMonth: 31,
    }
  },
  created() {
    this.loadList();
  },
  methods: {
    async loadList() {
      const conditions = []

      const year = this.nav.value.year ? Number(`${this.nav.value.year}`) : new Date().getFullYear();
      const month = this.nav.value.month ? Number(`${this.nav.value.month}`) : new Date().getMonth() + 1;
      const startDate = new Date(year, month - 1, 1).format("yyyy-MM-dd");
      const endDate = new Date(year, month, 1).format("yyyy-MM-dd");
      conditions.push({ key: "header.date", operator: ">=", value: startDate });
      conditions.push({ key: "header.date", operator: "<", value: endDate });

      // 연월에 따른 일자 변경
      this.dayofMonth = new Date(year, month, 0).getDate();

      // 검색조건
      const heads = singlePageList[`${this.boardId}_list`].getHead().map(e => {return {[e.name] : e.key}});
      // 배열의 객체들을 하나의 객체로 합치기
      const types = Object.assign({}, ...heads);
      if (this.nav.value.column && this.nav.value.column.keyword) {
        conditions.push({key: types[this.nav.value.column.head], operator: 'LIKE', value: `%${this.nav.value.column.keyword}%`})
      }

      const boardId = 1040;
      const postList = [];
      this.loading(true);
      try {
        const list = await this._loadList(boardId, conditions);
        postList.push(...list);
      } catch (e) {

      }

      const list = [];
      console.log('postList', postList.length, postList);
      for(const post of postList) {
        const content = JSON.parse(post.post_content)
        const 인원투입현황 = content.body.인원투입현황
        for (const 인원 of 인원투입현황) {
          const 성명 = 인원.성명
          const 주민등록번호 = `${인원.rrn1}-${인원.rrn2}******`
          const 직종 = 인원.직종 === "직접입력"? 인원.직종직접입력 : 인원.직종
          const day = new Date(content.header.date).getDate()
          const 단가 = 인원.단가? 인원.단가 : 0

          const listIndex = list.findIndex((item) => item.성명 === 성명 && item.단가 === 단가);
          if (listIndex !== -1) {
            list[listIndex][day] = (list[listIndex][day] || 0) + 1;
            list[listIndex].투입일 += 1
            if (list[listIndex].단가) {
              list[listIndex].총금액 += 단가
            }
            if (인원.비고 && 인원.비고 !== "") {
              list[listIndex]['비고'] = list[listIndex]['비고'] ? `${list[listIndex]['비고']}, ${인원.비고}` : 인원.비고;
            }
          } else {
            list.push({
              성명: 성명,
              주민등록번호: 주민등록번호,
              연락처: 인원.연락처,
              소속: 인원.소속,
              직종: 직종,
              주소: 인원.주소,
              투입일: 1,
              단가: 단가,
              총금액: 단가,
              비고: 인원.비고,

              대상년도: content.header.year,
              사업장명: content.body.stdInfo.field_name,
              작업일: content.header.date,
            })
            list[list.length - 1][day] = 1
          }

        }
      }
      this.list = list
      this.list.sort((a, b) => {
        if (a.성명 < b.성명) return -1;
        if (a.성명 > b.성명) return 1;
        return a.단가 - b.단가;
      });
      this.loading(false);

    },

    async _loadList(boardId, conditions) {
      const projectId = this.projectId;
      const page = 1;
      const perPage = 50;
      return await this._loadDefragmentation({
        projectId,
        boardId,
        page,
        perPage,
        conditions,
      });
    },
    async _loadDefragmentation(options) {
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
      const list = [];
      list.push(...response.data);
      if (response.current_page !== response.last_page) {
        options.page = response.current_page + 1;
        list.push(... await this._loadDefragmentation(options));
      }
      return list
    },

    onClickSearch () {
      this.loadList()
    },

    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },

    findJsonDataWithDottedPath (json, path) {
      try {
        const _keys = Object.keys(json)
        if (_keys.length === 0) {
          return '';
        }
        const paths = path.split('.')
        let result = json
        for (const p of paths) {
          result = result[p]
        }
        return result
      } catch (err) {
        return ''
      }
    },

    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },

    onClickExcelDownload() {
      // 기본 헤더 정의
      const baseHeaders = [
        '성명', '연락처', '소속', '직종'
      ];

      // 날짜 헤더 추가
      const dateHeaders = [];
      for (let i = 1; i <= this.dayofMonth; i++) {
        dateHeaders.push(`${i}`);
      }
      dateHeaders.push('투입일');

      // 나머지 헤더 추가
      const remainingHeaders = ['단가', '총금액', '비고'];

      // 데이터 변환
      const excelData = this.list.map(row => {
        const newRow = {};
        // 기본 정보
        newRow['성명'] = row.성명;
        newRow['연락처'] = row.연락처;
        newRow['소속'] = row.소속;
        newRow['직종'] = row.직종;

        // 투입현황
        for (let i = 1; i <= this.dayofMonth; i++) {
          newRow[`${i}일`] = row[i] || '';
        }
        newRow['투입일'] = row.투입일;

        // 나머지 정보
        newRow['단가'] = row.단가;
        newRow['총금액'] = row.총금액;
        newRow['비고'] = row.비고;

        return newRow;
      });

      // 합계 행 추가
      const totalRow = {
        '성명': '합 계',
        '총금액': this.총합계
      };
      excelData.push(totalRow);

      // 워크시트 생성
      const ws = XLSX.utils.aoa_to_sheet([
        // 첫 번째 행: 기본 헤더 + 투입현황(병합) + 나머지 헤더
        [...baseHeaders, '투입현황', ...remainingHeaders],
        // 두 번째 행: 기본 헤더 + 날짜 헤더 + 나머지 헤더
        [...baseHeaders, ...dateHeaders, ...remainingHeaders]
      ]);

      // 데이터 추가
      XLSX.utils.sheet_add_json(ws, excelData, {
        origin: 'A3',
        skipHeader: true
      });

      // 셀 병합 설정
      ws['!merges'] = [
        // 투입현황 셀 병합 (첫 번째 행)
        {
          s: { r: 0, c: baseHeaders.length }, // 시작 셀 (투입현황 시작)
          e: { r: 0, c: baseHeaders.length + this.dayofMonth } // 끝 셀 (투입일까지)
        },
        // 기본 정보 셀 병합 (1-2행)
        ...baseHeaders.map((_, index) => ({
          s: { r: 0, c: index },
          e: { r: 1, c: index }
        })),
        // 나머지 정보 셀 병합 (1-2행)
        ...remainingHeaders.map((_, index) => ({
          s: { r: 0, c: baseHeaders.length + this.dayofMonth + 1 + index },
          e: { r: 1, c: baseHeaders.length + this.dayofMonth + 1 + index }
        }))
      ];

      // 첫 번째 행의 셀 값과 스타일 설정
      const firstRowStyle = { alignment: { vertical: 'center', horizontal: 'center' } };
      for (let i = 0; i < baseHeaders.length; i++) {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: i });
        if (!ws[cellRef]) ws[cellRef] = {};
        ws[cellRef].v = baseHeaders[i];
        ws[cellRef].s = firstRowStyle;
      }
      for (let i = 0; i < remainingHeaders.length; i++) {
        const cellRef = XLSX.utils.encode_cell({ r: 0, c: baseHeaders.length + this.dayofMonth + 1 + i });
        if (!ws[cellRef]) ws[cellRef] = {};
        ws[cellRef].v = remainingHeaders[i];
        ws[cellRef].s = firstRowStyle;
      }

      // 열 너비 설정
      const allHeaders = [...baseHeaders, ...dateHeaders, ...remainingHeaders];
      ws['!cols'] = allHeaders.map((_, index) => {
        // 기본 정보와 나머지 정보는 15
        if (index < baseHeaders.length || index >= baseHeaders.length + this.dayofMonth + 1) {
          return { wch: 15 };
        }
        // 투입일 컬럼은 5
        if (index === baseHeaders.length + this.dayofMonth) {
          return { wch: 5 };
        }
        // 날짜 컬럼은 3.5
        return { wch: 3.5 };
      });

      // 워크북 생성
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "인원투입현황");

      // 파일명 생성 (현재 날짜 포함)
      const fileName = `인원투입현황_${new Date().toISOString().split('T')[0]}.xlsx`;

      // 엑셀 파일 다운로드
      XLSX.writeFile(wb, fileName);
    },

    onClickPrint() {
      // 인쇄용 스타일시트 정의
      const printStyles = `
        @media print {
          body * {
            visibility: hidden;
          }
          #app-content {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
          }
          table, table * {
            visibility: visible;
          }
          table {
            width: 100%;
            position: absolute;
            left: 0;
            top: 0;
          }
          .vs-button, .search-layout {
            display: none !important;
          }
          @page {
            size: landscape;
            margin: 10mm;
          }
        }
      `;

      // 인쇄용 스타일시트 생성
      const styleElement = document.createElement('style');
      styleElement.id = 'print-style';
      styleElement.innerHTML = printStyles;
      document.head.appendChild(styleElement);

      // 인쇄 실행
      window.print();

      // 인쇄 다이얼로그가 닫힌 후 스타일시트 제거 (setTimeout으로 약간의 딜레이 추가)
      setTimeout(() => {
        const printStyle = document.getElementById('print-style');
        if (printStyle) {
          document.head.removeChild(printStyle);
        }
      }, 1000);
    }
  } // methods
}
</script>

<style lang="scss" scoped>
table {
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  width: 100%;
  border: 1px solid #e0e0e0; // 테이블 전체에 경계선 추가

  thead {
    th {
      white-space: nowrap;
      background-color: #f9f9f9;
      padding: 10px 0;
    }
  }
  tbody {
    th {
      padding: 10px 0;
    }
    td {
      background-color: #ffffff;
    }
  }

  th, td {
    border: 1px solid #e0e0e0;
    text-align: center;
    padding: 4px;
    margin: 0;
    box-sizing: border-box;
  }
}

.table-container {
  width: 100%;
  overflow-x: auto;
  position: relative;
}

.sticky-table {
  border-collapse: collapse !important;
  border-spacing: 0 !important;
}

.sticky-cell {
  position: sticky;
  left: 0;
  z-index: 2;
  background-color: inherit;
  /* 기존 오른쪽 테두리 제거 */
  border-right: none !important;

  /* 가상 요소로 오른쪽 테두리 생성 */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 1px;
    background-color: #e0e0e0;
    z-index: 3;
  }
}

thead .sticky-cell {
  background-color: #f9f9f9;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

tbody .sticky-cell {
  background-color: #ffffff;
  box-shadow: 2px 0 5px -2px rgba(0, 0, 0, 0.1);
}

/* 합계 행의 고정 셀 */
tbody tr:last-child .sticky-cell {
  background-color: #f9f9f9;
}
</style>
